module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am291-e282380512536a84366e532e107a9d60.jpg";